import type { BeckyRequestPayload } from '@wix/thunderbolt-becky-root'

export const shouldSplitByPresets = (payload: BeckyRequestPayload) => payload.shouldSplitByPresets === 'true'
export const shouldRunVsmFromPayload = (payload: BeckyRequestPayload) => payload.shouldRunVsm === 'true'
export const shouldReturnResolvedBeckyModelFromPayload = (payload: BeckyRequestPayload) =>
	payload.shouldReturnResolvedBeckyModel === 'true'

export const shouldReturnCssObject = (payload: BeckyRequestPayload) => payload.shouldGetCssResultObject === 'true'
